import { render, staticRenderFns } from "./create-estimated-exchange-rate.vue?vue&type=template&id=2038c2a4"
import script from "./create-estimated-exchange-rate.vue?vue&type=script&lang=ts"
export * from "./create-estimated-exchange-rate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports